import { useMyAssortmentTranslation } from '@retail/my-assortment/i18n';
import { DiscontinuationStatus } from '@retail/products/types';

export const getDiscontinuationStatus = (status: DiscontinuationStatus) => {
  const { t } = useMyAssortmentTranslation();
  switch (status) {
    case 'EXPIRES_NO_REPLACEMENT':
      return t('myAssortment.discontinuationStatus.expiresNoReplacement');
    case 'EXPIRES_WITH_REPLACEMENT':
      return t('myAssortment.discontinuationStatus.expiresWithReplacement');
    case 'NEW_GTIN':
      return t('myAssortment.discontinuationStatus.newGtin');
    case 'REMOVED':
      return t('myAssortment.discontinuationStatus.removed');
    case 'SEASONAL_ITEM':
      return t('myAssortment.discontinuationStatus.seasonalItem');
    case 'SOLD_OUT':
      return t('myAssortment.discontinuationStatus.soldOut');
  }
};
